"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleRemoveAllImages;
const either_1 = require("../../../types/either");
const RemoveAllImages_1 = require("../../../actions/RemoveAllImages");
const UserPhotoLayer_1 = require("../../../models/layers/UserPhotoLayer");
const updateProjectVersion_1 = __importDefault(require("../updateProjectVersion"));
function handleRemoveAllImages(project, action) {
  return __awaiter(this, void 0, void 0, function* () {
    if (!(0, RemoveAllImages_1.isRemoveAllImages)(action)) {
      return (0, either_1.left)(new Error('Action does not match update project name schema'));
    }
    const newProject = (0, updateProjectVersion_1.default)(project, action);
    const interiorPrintableGroupIndex = project.printableGroups.findIndex(p => p.type === 'interior');
    if (interiorPrintableGroupIndex < 0) {
      return (0, either_1.left)(new Error(`Could not find interior printable group for project ${project.id}`));
    }
    const updatedEntities = [];
    newProject.printableGroups[interiorPrintableGroupIndex].printables.forEach(p => {
      let isPrintableUpdated = false;
      p.layers.forEach(l => {
        if ((0, UserPhotoLayer_1.isUserPhotoLayer)(l) && l.userData) {
          isPrintableUpdated = true;
          l.userData = undefined;
        }
      });
      if (isPrintableUpdated) {
        updatedEntities.push(p);
      }
    });
    return (0, either_1.right)({
      updatedProject: newProject,
      updatedEntities: updatedEntities ? [newProject, ...updatedEntities] : [newProject]
    });
  });
}